import { render, staticRenderFns } from "./redirect-page.vue?vue&type=template&id=7dce9bd5&scoped=true&"
import script from "./redirect-page.vue?vue&type=script&lang=js&"
export * from "./redirect-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dce9bd5",
  null
  
)

export default component.exports